import {
    GET_COLLATERALS_REQUEST,
    GET_COLLATERALS_SUCCESS,
    GET_COLLATERALS_ERROR
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_COLLATERALS_REQUEST:
            return {
                loading: true,
            };
        case GET_COLLATERALS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_COLLATERALS_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}